// extracted by mini-css-extract-plugin
module.exports = {"root":"_1xPrW","emptyItem":"_2cVqz"};